module.exports = __webpack_public_path__ + "static/media/hands_11.c1100226.svg";